// extracted by mini-css-extract-plugin
module.exports = {"comparisonTable":"comparisonTable_comparisonTable__3w9J2"};